export enum QuickContactModalMode {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
}
